module.exports = __webpack_public_path__ + "img/faq-rivoneed.bfbf1d44.webp";